import React from 'react'

import { Radio } from '@/app/component/atom/form'

export type DownloadExtension = 'xlsx' | 'csv'

type Props = {
  onChange: (data: { name: string; value: string }) => void
}

const values: Array<{ label: string; value: DownloadExtension }> = [
  {
    label: '.xlsx',
    value: 'xlsx',
  },
  {
    label: '.csv',
    value: 'csv',
  },
]

const DownloadDialogContent: React.FC<Props> = ({ onChange }) => {
  const [extension, setExtension] = React.useState<DownloadExtension>('xlsx')

  const handleChange = (data: { name: string; value: string }) => {
    setExtension(data.value as DownloadExtension)
    onChange(data)
  }

  return (
    <div>
      <div style={{ marginBottom: '12px' }}>Choose the file format you wish to download the contacts in:</div>
      <Radio name="downloadFileExtension" value={extension} values={values} onChange={handleChange} />
    </div>
  )
}

export default DownloadDialogContent

export type { Props as DownloadDialogContentProps }
